import * as Yup from "yup";
import { PaymentExpectationSourceType } from "../constants/payment-expectation.constants";

const ALLOWED_SOURCE_TYPES = [
  PaymentExpectationSourceType.INVOICE,
  PaymentExpectationSourceType.ADVANCE,
];

export default Yup.object({
  sourceType: Yup.string()
    .oneOf(ALLOWED_SOURCE_TYPES, "Invalid source type")
    .required("Source type is required"),
  sourceId: Yup.number().nullable().default(null),
  clientId: Yup.number().nullable().default(null),
  expectedAmount: Yup.number()
    .typeError("Enter a valid amount")
    .positive("Amount must be greater than 0")
    .required("Expected amount is required"),
  expectedDate: Yup.string().required("Expected date is required"),
  promisedBy: Yup.string().nullable().default(null),
  followUpDate: Yup.string()
    .nullable()
    .default(null)
    .test(
      "followup-before-expected",
      "Follow-up date must be on or before the expected date",
      function (followUp) {
        const expected = this.parent.expectedDate as string | undefined;
        if (!followUp || !expected || String(followUp).trim() === "") return true;
        return String(followUp) <= String(expected);
      },
    ),
  remarks: Yup.string().nullable().default(null),
});
